module.exports = __webpack_public_path__ + "7667b129d17983db646d9b5687013b62.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/company/logo.png
// module id = ./assets/images/company/logo.png
// module chunks = 0